"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M21.905 12.586c.064-.162.096-.335.095-.51.003-.18-.03-.357-.095-.524l-.007-.016-.008-.015a1.494 1.494 0 0 0-.137-.21 1.007 1.007 0 0 0-.119-.178l-.006-.008-5.483-5.683a1.375 1.375 0 0 0-1.984 1.904l3.219 3.32H3.356a1.356 1.356 0 1 0 0 2.712h14.047l-3.056 3.302a1.371 1.371 0 0 0 .068 1.933 1.37 1.37 0 0 0 1.932-.066l5.273-5.525a.82.82 0 0 0 .154-.223l.12-.185.01-.028Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};